import { createAction } from 'redux-actions';
import { reduxKey } from '../../constants';
import { GdprWidgetStep } from './types';
import {
  PapiRequestSettingsGdprConfirmRemove,
  PapiRequestSettingsGdprRequestData,
  PapiRequestSettingsGdprRequestRemove,
  PapiRequestSettingsGdprResendLink,
  PapiRequestSettingsGdprResendRemoveConfirmation,
} from '@wix/da-papi-types';

function createNetworkRequestActionSet<RequestDataType>(actionName: string) {
  return {
    submit: createAction(
      `${reduxKey}.${actionName}`,
      (data: RequestDataType) => ({ data })
    ),
    success: createAction(`${reduxKey}.${actionName}_SUCCESS`, () => ({})),
    failure: createAction(
      `${reduxKey}.${actionName}_FAILURE`,
      (errorMessage: string) => ({ errorMessage })
    ),
  };
}

export const setGdprWidgetStep = createAction(
  `${reduxKey}.SET_GDPR_WIDGET_STEP`,
  (step: GdprWidgetStep) => ({ step })
);

export const {
  submit: submitPersonalDataRequest,
  success: submitPersonalDataRequestSuccess,
  failure: submitPersonalDataRequestFailure,
} = createNetworkRequestActionSet<PapiRequestSettingsGdprRequestData>(
  'SUBMIT_PERSONAL_DATA_REQUEST'
);

export const {
  submit: submitPersonalDataRemoveRequest,
  success: submitPersonalDataRemoveRequestSuccess,
  failure: submitPersonalDataRemoveRequestFailure,
} = createNetworkRequestActionSet<PapiRequestSettingsGdprRequestRemove>(
  'SUBMIT_PERSONAL_DATA_REMOVE_REQUEST'
);

export const {
  submit: submitPersonalDataConfirmRemoval,
  success: submitPersonalDataConfirmRemovalSuccess,
  failure: submitPersonalDataConfirmRemovalFailure,
} = createNetworkRequestActionSet<PapiRequestSettingsGdprConfirmRemove>(
  'SUBMIT_PERSONAL_DATA_CONFIRM_REMOVAL'
);

export const {
  submit: submitPersonalDataResendDownloadLink,
  success: submitPersonalDataResendDownloadLinkSuccess,
  failure: submitPersonalDataResendDownloadLinkFailure,
} = createNetworkRequestActionSet<PapiRequestSettingsGdprResendLink>(
  'SUBMIT_PERSONAL_DATA_RESEND_DOWNLOAD_LINK'
);

export const {
  submit: submitPersonalDataResendDataRemovalConfirmationLink,
  success: submitPersonalDataResendDataRemovalConfirmationLinkSuccess,
  failure: submitPersonalDataResendDataRemovalConfirmationLinkFailure,
} = createNetworkRequestActionSet<PapiRequestSettingsGdprResendRemoveConfirmation>(
  'SUBMIT_PERSONAL_DATA_RESEND_DATA_REMOVAL_CONFIRMATION_LINK'
);
